import { BookingButton } from '@/components/booking/BookingButton'

/** Mobile-only sticky conversion bar */
export function StickyBookBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 border-t border-olive-border bg-olive p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-[var(--shadow-olive)] min-[900px]:hidden">
      <BookingButton variant="onDark" className="w-full justify-center" />
    </div>
  )
}
